angular.module('impactx.approval').controller('ApprovalSelectionViewCtrl', ['$scope', ApprovalSelectionViewCtrl]);

function ApprovalSelectionViewCtrl($scope) {

    $scope.showDialog = false;

    this.addApprover = function (user) {
        var alreadyInserted = false;
        $scope.resultEntries.forEach(function (entry) {
            if (entry.id == user.id) alreadyInserted = true;
        });
        if (user && !alreadyInserted) $scope.resultEntries.push({user: user});
        this.toggleDialog();
    };

    this.getSelectableApprover = function (approver, resultEntries) {
        approver = approver.filter(function (el) {
            return resultEntries.indexOf(el) < 0;
        });
        return approver;
    };

    this.toggleDialog = function () {
        $scope.showDialog = !$scope.showDialog;
    };

    this.getUserAvatar = function (user) {
        var imageUrl = "img/profile_image_default.png";
        if (user.imageUrl) {
            imageUrl = user.imageUrl;
        }

        return imageUrl
    };

    $(document).on('click', function (event) {
        if ($(event.target).closest('.selection-dialog-approval').length === 0 &&
            $(event.target).closest('#' + $scope.selectionId).length === 0) {
            $scope.showDialog = false;
            $scope.$evalAsync();
        }
    });
}